import React from "react";
import SalesAccountTable from "./SalesAccountTable";

const index = () => {
  return (
    <div>
      <SalesAccountTable />
    </div>
  );
};

export default index;
